import img from "../assets/images/shutterstock_699442570-min.jpg";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";

export default function Reports() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    clientType: "",
    interests: [],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      interests: checked
        ? [...prev.interests, value]
        : prev.interests.filter((interest) => interest !== value),
    }));
  };

  async function handleSubmit(event) {
    event.preventDefault();

    const submissionData = {
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Lead Interested in Real Estate Reports",
      Name: formData.name,
      "Email Address": formData.email,
      "Client Type": formData.clientType,
      "Interested in:": formData.interests,
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(submissionData),
      });

      const data = await res.json();

      if (data?.success) {
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  const seoConfig = pageSEO.reports();
  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] pt-[150px] mx-auto grid md:grid-cols-2 px-6 gap-x-24 gap-y-10 min-h-[70vh] mb-12">
        <div>
          <h1 className="text-4xl text-black libre">
            Free Real Estate Reports
          </h1>

          <p className="font-semibold text-med-grey my-5">
            Get exclusive buyer & seller real estate reports to help you with
            your next purchase or sale. Get insider tips and tricks, and learn
            how to invest your time and money wisely in the real estate market.
            Just complete the form below, select all the reports you'd like to
            receive and have them emailed to your inbox right away. Get started
            now!
          </p>
          <form onSubmit={handleSubmit}>
            <div className="form-item">
              <label className="form-label">Name*</label>
              <input
                required
                className="form-input"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Full Name"
              />
            </div>
            <div className="form-item">
              <label className="form-label">Email*</label>
              <input
                required
                className="form-input"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email Address"
              />
            </div>
            <div className="form-item">
              <label className="form-label">I am a*</label>
              <select
                required
                className="form-input"
                name="clientType"
                value={formData.clientType}
                onChange={handleInputChange}
              >
                <option value="">Please Select</option>
                <option value="Buyer">Buyer</option>
                <option value="Seller">Seller</option>
                <option value="Renter">Renter</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="form-item">
              <label className="form-label">I am interested in:</label>
              <div className="grid grid-cols-2 gap-3 mt-3">
                <div className="cursor-pointer">
                  <input
                    className="mr-2"
                    type="checkbox"
                    id="buying-guides"
                    value="Buying guides"
                    checked={formData.interests.includes("Buying guides")}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="buying-guides">Guides for Buying</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    type="checkbox"
                    id="selling-guides"
                    value="Selling guides"
                    checked={formData.interests.includes("Selling guides")}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="selling-guides">Guides for Selling</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    type="checkbox"
                    id="choosing-realtor"
                    value="Choosing realtor"
                    checked={formData.interests.includes("Choosing realtor")}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="choosing-realtor">Choosing a Realtor</label>
                </div>
                <div>
                  <input
                    className="mr-2"
                    type="checkbox"
                    id="renovations"
                    value="Renovations"
                    checked={formData.interests.includes("Renovations")}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="renovations">Home Renovations</label>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="btn-tertiary self-start px-10 mt-3"
            >
              Submit
            </button>
          </form>
        </div>
        <div className="overflow-hidden h-[600px]">
          <img
            className="h-full w-full object-cover"
            src={img}
            alt="Real Estate"
          />
        </div>
      </div>
      {popup && (
        <>
          <div className="backdrop" />
          <div className="popup">
            <h5 className="font-bold text-black text-lg">{popup.subject}</h5>
            <p className="font-semibold text-med-grey tracking-wide mb-3">
              {popup.message}
            </p>
            <button onClick={() => setPopup(false)} className="btn-tertiary">
              Close
            </button>
          </div>
        </>
      )}
    </>
  );
}
